module.exports = __webpack_public_path__ + "img/henan.e99cf967.jpg";